import { ITemplateDetailRepository } from 'orders/domain/repositories/ITemplateDetailRepository'
import { TemplateDetailEntity } from 'orders/domain/entities/templateDetail.entity'
import { getTemplateDetail } from 'services/templateService'

export class TemplateDetailHttpRepository implements ITemplateDetailRepository {
    async getTemplateDetail(templateId: number): Promise<TemplateDetailEntity> {
        // TODO: replace with direct axios call when API contract is confirmed
        const data = await getTemplateDetail(templateId)
        return {
            id: data.id,
            name: data.name,
            groups: (data.groups ?? []).map((g: Record<string, unknown>) => {
                const rawProviderService = g.providerService
                const providerService =
                    rawProviderService !== null &&
                    typeof rawProviderService === 'object' &&
                    typeof (rawProviderService as Record<string, unknown>).code === 'string' &&
                    typeof (rawProviderService as Record<string, unknown>).name === 'string'
                        ? (rawProviderService as { code: string; name: string })
                        : null
                const maxCapacity =
                    typeof g.max_capacity === 'number' ? g.max_capacity : null
                const rawSequence = g.sequence
                const sequence =
                    typeof rawSequence === 'number'
                        ? rawSequence
                        : typeof rawSequence === 'string' && rawSequence.trim() !== '' && !Number.isNaN(Number(rawSequence))
                          ? Number(rawSequence)
                          : null
                return {
                    id: typeof g.id === 'number' ? g.id : undefined,
                    name: (g.name ?? g.group_name ?? '') as string,
                    sequence,
                    chutes: (g.chutes ?? []) as number[],
                    criterias: (g.criterias ?? []) as TemplateDetailEntity['groups'][0]['criterias'],
                    max_capacity: maxCapacity,
                    providerService,
                    change_route: (g.change_route ?? false) as boolean,
                }
            }),
        }
    }
}
